import { useDispatch, useSelector } from "react-redux";
import { BsCloudDownload } from "react-icons/bs";
import { useEffect, useState } from "react";
import { CiEdit } from "react-icons/ci";
import nodeinstance from "../../../../nodeInstance";
import React from "react";
import Highlighter from "react-highlight-words";
import EmployeePayment from "./employeePaymentpopup";
import { setAppError } from "../../../../store/userSlice";
import { getloanAdvanceData } from "../../../../store/Api";

export default function EmployeeDetails({
  EmployeeData = [],
  data,
  setLoanAmount,
  setRefreshData,
  flightId,
  refreshData,
}) {
  console.log("data ..........", data);
  const token = localStorage.getItem("nodeToken");
  const dispatch = useDispatch();
  const titles = [
    "S.NO",
    "EMPLOYEE NAME",
    "EMPLOYEE ID",
    "RELIGION",
    "COUNTRY",
    "VISA PROVIDER",
    "ARRIVAL SECTOR",
    "LOAN/ADVANCE",
    "INSTALLMENTS",
    "DOCUMENT RECEIVED AMOUNT",
    "CASH RECEIVED AMOUNT",
    "TRAVEL STATUS",
    "STATUS",
    "ACTION",
  ];

  const [popup, setPopUp] = useState(false);
  const [propData, setPropData] = useState();

  const [showPromptElement, setShowPromptElement] = useState(false);
  const [popUpData, setPopUpData] = useState();

  const handleIconClick = (data) => {
    setShowPromptElement(true);
    setPopUpData(data);
  };
  const handlePopupSubmission = () => {
    setRefreshData(true);
  };

  console.log(
    "searchWordssearchWords..........f.f.f.f.f.f.f.f.f",
    EmployeeData
  );
  const downloadPaymentReceipt = async (id) => {
    try {
      const response = await nodeinstance.get(
        `/dashboard/loanAdvance/download/${id}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("response", response);
      if (response.status === 200) {
        const contentType = response.headers["content-type"];
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        // Create a temporary anchor element
        const link = document.createElement("a");
        link.href = url;

        // Set the download attribute to specify the filename
        if (contentType.includes("application/pdf")) {
          link.setAttribute("download", "employee_loan_receipt.pdf");
        } else if (contentType.includes("image")) {
          link.setAttribute("download", "IMAGE_FILE.png"); // Change the extension as per the image format
        } else {
          throw new Error("Unsupported file type!");
        }

        // Append the anchor to the body and trigger the click event
        document.body.appendChild(link);
        link.click();

        // Cleanup: Revoke the object URL and remove the link
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      dispatch(
        setAppError({
          msg: "No Pdf found.",
        })
      );
    }
  };
  let EmployeeCount = EmployeeData?.reduce((count, employee) => {
    if (employee?.employee_cash_status === null) {
      return count + 1;
    }
    return count;
  }, 0);

  const totalLoanAdvance = EmployeeData?.reduce((total, item) => {
    return total + Number(item.loan_advance || 0);
  }, 0);

  const [downloadLoading, setDownloadLoading] = useState(false);
  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `/dashboard/loanAdvance/downloadEmployeeList/${flightId}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `EMPLOYEE_LOAN_ADVANCE_LIST`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  return (
    <>
      <div className="pt-2 uppercase m-3">
        {/* <div className="flex flex-wrap  gap-2 w-full items-center "> */}
        <div
          className="flex flex-wrap gap-2 mb-1 items-center"
          style={{ backgroundColor: "white" }}
        >
          <h3
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginLeft: "2rem",
              marginTop: "1rem",
            }}
            className="text-red"
          >
            {EmployeeData && EmployeeData[0]?.client_name} |{" "}
            {data?.flight_details}
            {/* <span style={{ textAlign: "right" }}>AMOUNT</span> */}
          </h3>
          <h3
            style={{ textAlign: "right", marginTop: "1rem" }}
            className="ml-auto text-lg text-red"
          >
            YET TO RECEIVE EMP. COUNT : {EmployeeCount ? EmployeeCount : 0} |{" "}
            {""} AMOUNT :{" "}
            {Number(totalLoanAdvance ?? 0).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}{" "}
            {""}
          </h3>
          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2 ml-10 mt-4 m-2"
            disabled={downloadLoading}
            onClick={() => downloadFile()}
          >
            Download LIST
          </button>
          <div
            className="overflow-x-auto m-2"
            style={{
              backgroundColor: "white",
              height: EmployeeData?.length > 2 ? "250px" : "",
            }}
          >
            <table className="min-w-full divide-gray-200">
              <thead className="bg-gray-100">
                <tr>
                  {titles.map((columnName, index) => (
                    <th
                      key={index}
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider font-semibold"
                    >
                      {columnName}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white divide-gray-10">
                {EmployeeData.map((listItem, index) => (
                  <tr key={index}>
                    <td className="px-6 py-4 whitespace-nowrap">{index + 1}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem?.employee_name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.employee_id}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.religion}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.country}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.visa_provider ? listItem.visa_provider : "--"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.arrival_sector}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.loan_advance}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.loan_advance_installment}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.document_receipt_amount
                        ? listItem.document_receipt_amount
                        : 0}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.cash_receipt_amount
                        ? listItem.cash_receipt_amount
                        : 0}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.status}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.employee_cash_status === null
                        ? "YET TO RECEIVE"
                        : listItem.employee_cash_status}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <button
                        className="rounded-md bg-white p-2 text-sm text-black border border-gray-500 mr-3"
                        style={{
                          width: "2rem",
                          height: "2rem",
                          fontSize: "1rem",
                        }}
                        onClick={() => {
                          handleIconClick(listItem);
                        }}
                        disabled={
                          listItem.loan_advance === null ||
                          listItem.employee_cash_status !== null
                        }
                      >
                        <CiEdit size={"1rem"} />
                      </button>
                      <button
                        className="rounded-md bg-white p-2 text-sm text-black border border-gray-500 mr-3"
                        style={{
                          width: "2rem",
                          height: "2rem",
                          fontSize: "1rem",
                        }}
                        onClick={() => {
                          downloadPaymentReceipt(listItem.employee_id);
                        }}
                        disabled={
                          listItem.employee_cash_status === null
                        }
                      >
                        <BsCloudDownload size={"1rem"} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {
          <EmployeePayment
            setShowPromptElement={setShowPromptElement}
            showPromptElement={showPromptElement}
            popUpData={popUpData}
            amountRequested={data}
            onSubmission={setRefreshData}
            refreshData={refreshData}
          />
        }
      </div>
    </>
  );
}
